// 商品路由
const name = '店鋪'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/dealer/setting',
  component: Layout,
  children: [
    {
      path: 'baseexport',
      name: `匯出列表`,
      component: () => import('@/view/base/exportlog/index')
    },
    {
      path: 'account_management',
      name: `帳號管理`,
      component: () => import('@/view/dealer/account')
    }
  ]
}
